<template>
  <div class="footer-view">
    <div class="footer">
      <div class="logo-box" @click="$router.push('/')">
        <div class="img-box">
          <img
            style="transform: rotate(45deg); width: 60px; height: 60px"
            src="../../assets/images/logo/logo-left.gif"
            alt=""
          />
        </div>
      </div>
      <ul>
        <li>
          <p class="first-child">新手指南</p>
          <p class="first-child">平台声明</p>
          <p class="first-child">关于我们</p>
          <p class="first-child">友情链接</p>
        </li>
        <li>
          <p>
            <router-link to="/userProtocol/use-help">使用帮助</router-link>
          </p>
          <p><router-link to="/userProtocol/protocol">用户协议</router-link></p>
          <p>
            <router-link to="/userProtocol/introduction">易缆网</router-link>
          </p>
          <p>
            <a target="_blank" href="http://www.zhaozhouwang.cn/">找轴网</a>
          </p>
        </li>
        <li>
          <p>
            <router-link to="/userProtocol/conditions">入驻条件</router-link>
          </p>
          <p>
            <router-link to="/userProtocol/privacy-policy"
              >隐私政策</router-link
            >
          </p>
          <p>
            <router-link to="/userProtocol/privacy-policy"
              >隐私政策</router-link
            >
          </p>
          <p style="cursor: pointer" @click="openOptionDialog">意见建议</p>
        </li>
        <li>
          <p>
            <router-link to="/userProtocol/Certification">认证指南</router-link>
          </p>
          <p><router-link to="">平台公告</router-link></p>
        </li>
      </ul>
      <div class="contact-us">
        <div style="display: flex">
          <div v-for="(item, index) in imgUrl" :key="index">
            <el-popover placement="top" width="120" trigger="click">
              <img class="qrcode-img" :src="item.qrcodeUrl" alt="" />
              <div class="qr-code" slot="reference">
                <img :src="item.icon" alt="" />
              </div>
            </el-popover>
          </div>
        </div>
        <div class="prompt">点击图标查看二维码</div>
        <p class="link">
          商务合作 : <span style="color: #191919">李建帅 19133394000</span>
        </p>
      </div>
    </div>
    <div class="filings">
      <div class="police">
        <img class="img" src="@/assets/images/gongwang.png" alt="" />
        <div class="license">
          <a
            href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011302006374"
            target="_blank"
            >冀公网安备13052802001976号</a
          >
        </div>
        <div class="liner">|</div>
      </div>
      <div class="license">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"
          >冀ICP备2023005338号-2</a
        >
      </div>
      <div class="liner">|</div>
      <div
        class="license"
        @click="jump('/static/valueAddedTelecomBusinessLicense.png')"
      >
      增值电信业务经营许可证
      </div>
      <div class="liner">|</div>
      <div class="license" @click="jump('/static/businessLicense.png')">
        营业执照
      </div>
      <div class="liner">|</div>
      <div><span>&nbsp;</span>Copyright©河北易缆网络科技有限公司 版权所有</div>
    </div>
    <MessageBorad ref="mesage"></MessageBorad>
  </div>
</template>
<script>
import MessageBorad from "@/components/messageBoard/index.vue";
export default {
  components: {
    MessageBorad,
  },
  data() {
    return {
      imgUrl: [
         {
          icon: require("@/assets/images/wechat.png"),
          qrcodeUrl: require("@/assets/images/qrcode2.jpg"),
        },
        {
          icon: require("@/assets/images/gongzhonghao.png"),
          qrcodeUrl: require("@/assets/images/qrcode.jpg"),
        },
        {
          icon: require("@/assets/images/douyin.png"),
          qrcodeUrl: require("@/assets/images/qrcode3.png"),
        },
        {
          icon: require("@/assets/images/kuaishou.png"),
          qrcodeUrl: require("@/assets/images/qrcode4.png"),
        },
        {
          icon: require("@/assets/images/shipinhao.png"),
          qrcodeUrl: require("@/assets/images/qrcode5.png"),
        },
        {
          icon: require("@/assets/images/toutiao.png"),
          qrcodeUrl: require("@/assets/images/qrcode6.png"),
        },
      ],
    };
  },
  computed: {
    isLogin() {
      return this.$store.getters["user/isLogin"];
    },
  },
  methods: {
    openOptionDialog() {
      if (this.isLogin) {
        this.$refs.mesage.dialogFormVisible = true;
      } else {
        this.$router.push({
          path: "/login",
        });
      }
    },
    jump(url) {
      window.open(url);
    },
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.footer-view {
  min-width: 1200px;
  background: #e8e8e8;
}
ul,
li {
  list-style: none;
}

.footer {
  box-sizing: border-box;
  padding: 15px calc((100% - 1200px) / 2);
  display: flex;
  height: 153px;
  justify-content: space-between;

  ul {
    width: 700px;
    li {
      height: 31px;
      display: flex;
      align-items: center;
      line-height: 31px;
    }
    li > p {
      font-size: 14px;
      font-weight: normal;
      color: #393939;
      height: 100%;
      width: 134px;
      text-align: center;
      a {
        text-decoration: none;
        color: #393939;
      }
      a:hover {
        color: #ff0000 !important;
      }
    }
    .first-child {
      font-weight: 500;
      font-size: 16px;
      color: #191919;
    }
  }
  .contact-us {
    margin-top: 30px;
    .prompt {
      margin-top: 9px;
      margin-bottom: 23px;
      font-size: 14px;
      color: #191919;
      opacity: 0.7;
    }
    .link {
      margin-top: 14px;
      font-size: 14px;
      color: #191919;
      font-weight: bold;
    }
    .qr-code {
      width: 24px;
      height: 24px;
      margin-right: 11px;
      img {
        width: 100%;
      }
    }
  }
}
.qrcode-img {
  height: 120px;
  width: 120px;
}
.filings {
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #898989;
  box-sizing: border-box;
  font-size: 14px;
  font-weight: 400;
  color: #808080;
  background: #e8e8e8;
}
.license {
  cursor: pointer;
  a {
    text-decoration: none; /* 去除下划线 */
    color: inherit; /* 继承父元素的文本颜色 */
  }
}
.police {
  display: flex;
  height: 36px;
  align-items: center;
  .img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.liner {
  margin: 0 4px;
}
.copyright {
  height: 36px;
  line-height: 36px;
  text-align: center;
  color: #808080;
}
.logo-box {
  display: flex;
  align-items: center;
  cursor: pointer;
  .img-box {
    display: flex;
    align-items: center;
    img {
      &:nth-child(1) {
        width: 80px;
        height: 80px;
      }
    }
  }
  p {
    padding: 0;
    margin: 0;
    margin-top: 6px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
  }
}
</style>
